// Esqueleto de carga: un bloque gris que late mientras llega el contenido (quieto si la persona
// prefiere menos movimiento). Solo es decoración: el estado lo anuncia quien lo usa.
export const SKELETON = 'block bg-earth-100 animate-pulse motion-reduce:animate-none'

export const Skeleton = ({ className = '' }: { className?: string }) => (
	<span aria-hidden="true" className={`${SKELETON} rounded-2xl ${className}`.trim()} />
)
